<template>
  <div class="sim">
    <label for="">
      Selecione a cor e aplique na imagem abaixo:
    </label>
    <div class="flex gap18" :style="ladrilho.floral || ladrilho.horizontal ? 'flex-direction:column;' : ''">
      <div class="col">
        <SVGStyle @changeColor="changeColor" :cores="cores" :ladrilho="ladrilhoAct" :cor="cor" @corUtil="corUtil" @set="set"></SVGStyle>
      </div>
      <div class="col">
        <div class="overflow cores">
          <ul class="flex flex-wrap gap18" :style="ladrilho.floral || ladrilho.horizontal ? 'justify-content: center' : ''">
            <li v-for="(corAc, ind) in cores" @click="act = ind; cor = corAc" :class="ind == act ? 'act' : ''">
              <span :style="'background-color:' + corAc.hex"></span>
              {{ corAc.name }}
            </li>
          </ul>
        </div>
        <p class="mt-24">
          As cores são apenas demonstrativas e aproximadas, podendo sofrer variações no ladrilho real.
        </p>
        <div class="flex flex-end mt-24">
          <button @click="ChangePasso(2)" :disabled="getLocal() && !setI">ESCOLHER REJUNTE &gt;&gt;</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { default as colors } from '../assets/colors.json';
import SVGStyle from "@/components/SVGStyle";

export default {
  name: "Passo01",
  props: ['ladrilho'],
  components: {SVGStyle},
  data() {
    return {
      cores: colors,
      cor: '',
      act: '',
      setI: false,
      ladrilhoAct : ''
    }
  },
  methods: {
    ChangePasso(value) {
      this.$emit('changePasso', value);
    },
    set(val = false) {
      if(val)
        this.setI = true;
    },
    changeColor(emit) {
      console.log(emit);
      this.cor = emit.color;
      this.act = emit.ind;
    },
    corUtil(corUtil) {
      console.log(corUtil);
      this.$emit('corUtil', corUtil);
    },
    getLocal() {
      if(!this.ladrilho) {
        this.setI = false;
        return true
      }
      return !localStorage.getItem(this.ladrilho.svg)
    }
  },
  mounted() {
    this.cor = this.cores[0];
  },
  watch: {
    ladrilho() {
      this.ladrilhoAct = this.ladrilho;
    },
    cor() {
      this.$emit('changeCor', this.cor);
    }
  }
}
</script>

<style scoped>

.mt-24 {
  margin-top: 24px;
}
.sim {
  padding: 30px;
  background-color: #fff;
  margin-top: 60px;
}

label {
  font-size: 18px;
  display: block;
  font-weight: 700;
  margin-bottom: 15px;
}
button:disabled {
  opacity: 0.6;
}
.gap18 {
  gap: 12px 18px;
}

.flex-end {
  justify-content: flex-end;
}

p {
  line-height: normal;
}

.cores {
  max-height: 500px;
  overflow: auto;
  padding-right: 5px;
}

.cores{
  scrollbar-width: auto;
  scrollbar-color: #bfbfbf #ffffff
}
.cores::-webkit-scrollbar {
  width: 12px
}

.cores::-webkit-scrollbar-track {
  background: #ffffff
}

.cores::-webkit-scrollbar-thumb {
  background-color: #bfbfbf;
  border-radius: 10px;
  border: 3px solid #ffffff
}

.cores li {
  list-style: none;
  width: 84px;
  text-align: center;
  cursor: pointer;
  line-height: normal;
  text-align: center;
  cursor: pointer;
  font-family: Raleway,sans-serif;
  font-size: 14px;
  line-height: normal;
  color: #818181;
  font-weight: 400;
}

.cores li span {
  margin-bottom: 8px;
  width: 84px;
  display: block;
  height: 84px;
  padding: 8px;
  border-radius: 10px;
  box-sizing: border-box;
}

.cores li.act span {
  border: 4px solid black;
}

button:not(.vs__clear) {
  padding: 10px 26px;
  cursor: pointer;
  background-color: #6495ed;
  color: #fff;
  margin-top: 20px;
  font-size: 18px;
  appearance: none;
  border: none;
  border-radius: 4px;
}

</style>